import api from "../../core/api";
import { Role } from "../models/AdminRolesModels";

class AdminRolesApi {
  getRoles(): Promise<Role[]> {
    return api.get<Role[]>(`/v1/admin/roles`).then(x => x.data);
  }
}

export default new AdminRolesApi();